export interface ICredentials {
  email: string;
  password: string;
}

export enum AccountIcon {
  NONE = 'account',
  CHECK = 'account-check',
  EDIT = 'account-edit',
  OFF = 'account-off',
  REMOVE = 'account-remove',
}

export enum MaterialButtonType {
  DEFAULT = 'default',
  CLASSIC = 'classic',
  STROKED = 'stroked',
  FAB = 'fab',
  MINI_FAB = 'mini-fab',
  RAISED = 'raised',
}

export enum Layout {
  ROW = 'row',
  COLUMN = 'column',
}

export const EMAIL_REGEX = new RegExp(
  [
    '^(([^<>()[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)',
    '|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.',
    '[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+',
    '[a-zA-Z]{2,}))$',
  ].join('')
);

// eslint-disable-next-line max-len
export const PHONE_NUMBER_REGEX = new RegExp(
  [
    '^[+]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\.]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]{4,12}$',
  ].join('')
);
